<!--赖传峰-->
<!--2022/1/24-->
<!--eslint-disable max-len-->
<template>
  <DriveFeatureSVGSlot>
    <path
      :fill="props.color"
      clip-rule="evenodd"
      d="M24.2794 49.2C24.8839 49.2 25.374 48.71 25.374 48.1055V39.7474C25.374 39.1429 25.864 38.6528 26.4685 38.6528H28.4124C29.0169 38.6528 29.507 39.1429 29.507 39.7474V48.1055C29.507 48.71 29.997 49.2 30.6015 49.2H33.386C33.9905 49.2 34.4806 48.71 34.4806 48.1055V25.0945C34.4806 24.49 33.9905 24 33.386 24H30.6015C29.997 24 29.507 24.49 29.507 25.0945V33.0279C29.507 33.6324 29.0169 34.1225 28.4124 34.1225H26.4685C25.864 34.1225 25.374 33.6324 25.374 33.0279V25.0945C25.374 24.49 24.8839 24 24.2794 24H21.4949C20.8904 24 20.4004 24.49 20.4004 25.0945V48.1055C20.4004 48.71 20.8904 49.2 21.4949 49.2H24.2794ZM44.2785 49.2C47.0805 49.2 48.6216 48.0674 49.7424 46.7579C51.4061 44.8113 51.5861 41.3407 51.5999 38.3331L51.6 37.2738L51.5991 36.9332L51.5988 36.6C51.5988 36.4006 51.5993 36.1966 51.5998 35.9888L51.6 35.9262L51.5999 34.8669C51.5861 31.8593 51.4061 28.3888 49.7424 26.4422C48.6216 25.1326 47.0805 24 44.2785 24H38.3329C37.7284 24 37.2384 24.4901 37.2384 25.0946V48.1055C37.2384 48.71 37.7284 49.2 38.3329 49.2H44.2785ZM43.3067 44.6697H44.1735C45.0842 44.6697 45.7146 44.2096 46.0299 43.5725C46.5261 42.5992 46.6088 40.3232 46.6225 37.9735L46.625 37.2676V35.8631C46.6212 33.2856 46.5757 30.6982 46.0299 29.6275C45.7146 28.9905 45.0842 28.5303 44.1735 28.5303H43.3067C42.7022 28.5303 42.2121 29.0204 42.2121 29.6249V43.5751C42.2121 44.1796 42.7022 44.6697 43.3067 44.6697Z"
      fill-rule="evenodd"
    />
  </DriveFeatureSVGSlot>
</template>

<script
  lang="ts"
  setup
>
import IconPropsType from '@/components/icons/iconPropsType'
import DriveFeatureSVGSlot from './PremiumRightsSVGSlot.vue'

const props = defineProps({ color: IconPropsType.color })
</script>
